// Static Partners don't have a Voucher-Code configured in the backend.
// To be shown in the app, a partner needs to have an individual voucher in the backend or needs to be in this list with an optional static voucher-code in this document.
// Each partner specifies which platforms it should appear on to ensure proper filtering.
export const STATIC_PARTNERS = [
  { type: 'FPRE', platforms: ['bottimmo', 'falc'] },
  { type: 'IMMOW', platforms: ['bottimmo', 'falc'] },
  { type: 'HOLO_LOGIX', platforms: ['bottimmo', 'falc'] },
  { type: 'IMPROOV', platforms: ['bottimmo', 'falc'] },
  // { type: 'YNFINITE', platforms: ['bottimmo','falc'] }, // temporarily hidden
  // { type: 'REAL_X_LAB_PARTNER', platforms: ['bottimmo', 'falc', 'remax'] },
  { type: 'LOCAL_ON_TOP_PARTNER', platforms: ['bottimmo', 'falc', 'remax'] },
  { type: 'SELLER_LEADS', platforms: ['smg'] },
  { type: 'DISPLAY_WERBUNG', platforms: ['smg'] },
  { type: 'VISIBILITY_PLUS', platforms: ['smg'] },
  { type: 'REGIONAL_HIGHLIGHT', platforms: ['smg'] },
  // { type: 'CLICKLIFT', platforms: ['bottimmo','falc'] },
  // { type: 'ROCKET_SUITS', platforms: ['bottimmo','falc'] },
  // { type: 'STORYBOX', platforms: ['bottimmo','falc'] }, // temporaryily hidden due to partner request; should be enabled again in ca. 6 months
  // { type: 'IMMOVIEWER', platforms: ['bottimmo','falc'] }, // temporarily hidden
  { type: 'REGIONALIMMOBILIEN', platforms: ['bottimmo', 'falc'] },
  { type: 'SINCHEN_MEDIA', platforms: ['bottimmo', 'falc'] },
  { type: 'MAXX_CAPITAL', platforms: ['remax'] },
  { type: 'MAXX_FINANCE', platforms: ['remax'] },
  { type: 'PIXELWERKSTATT', platforms: ['bottimmo', 'falc'] },
  { type: 'JACASA', platforms: ['bottimmo', 'falc'] },
  { type: '4VISION', platforms: ['bottimmo', 'falc'] },
  { type: 'DEEPIMMO', platforms: ['bottimmo', 'falc'] },
  { type: 'MAKLERMITTELPUNKT', platforms: ['bottimmo', 'falc'] },
]

export const PARTNER_ORDER = [
  'SELLER_LEADS',
  'DISPLAY_WERBUNG',
  'VISIBILITY_PLUS',
  'REGIONAL_HIGHLIGHT',
  'DEEPIMMO',
  'MAKLERMITTELPUNKT',
  'IMPROOV',
  'PIXELWERKSTATT',
  'VON_FRED',
  'REDCUP',
  'IMMOW',
  'HOLO_LOGIX',
  // 'YNFINITE', // temporarily hidden
  'LOCAL_ON_TOP_PARTNER',
  'MAXX_CAPITAL',
  'MAXX_FINANCE',
  'MECOA',
  '4VISION',
  'SINCHEN_MEDIA',
  // 'MULTIPHONE', // temporaryily hidden; check registration link before enabling again
  'CLICKLIFT',
  'FIFY',
  'ROCKET_SUITS',
  'BEWERTUNGSLOESCHER',
  'FPRE',
  'SOLOWERK',
  // 'STORYBOX', // temporaryily hidden due to partner request; should be enabled again in ca. 6 months
  'PIXELMOTION',
  // 'IMMOVIEWER', // temporarily hidden
  'REGIONALIMMOBILIEN',
  // 'IMMO_BILLIE_PARTNER', // Removed: Not defined in PARTNER_TYPES
  'JACASA',
  // 'REAL_X_LAB_PARTNER',
]

export const PARTNER_TAGS = Object.freeze({
  ALL: 'ALL',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  SEO: 'SEO',
  CONTENT: 'CONTENT',
  LEARNING: 'LEARNING',
  LEAD_QUALITY: 'LEAD_QUALITY',
  FEEDBACK_MANAGEMENT: 'FEEDBACK_MANAGEMENT',
  DATA: 'DATA',
  WEBSITE_DEVELOPMENT: 'WEBSITE_DEVELOPMENT',
  LEAD_PROCESSING: 'LEAD_PROCESSING',
  OTHER: 'OTHER',
})

export const ReadablePartnerTags = Object.freeze({
  ALL: 'partner.tags.all',
  SOCIAL_MEDIA: 'partner.tags.social-media',
  SEO: 'partner.tags.seo',
  CONTENT: 'partner.tags.content',
  LEARNING: 'partner.tags.learning',
  LEAD_QUALITY: 'partner.tags.lead-quality',
  FEEDBACK_MANAGEMENT: 'partner.tags.feedback-management',
  DATA: 'partner.tags.data',
  WEBSITE_DEVELOPMENT: 'partner.tags.website-development',
  LEAD_PROCESSING: 'partner.tags.lead-processing',
  OTHER: 'partner.tags.other',
})

export const PARTNER_TYPES = {
  bottimmo: {
    DEEPIMMO: {
      subTitle: 'partner.partners.DEEPIMMO.subTitle',
      text: [
        'partner.partners.DEEPIMMO.text[0]',
        'partner.partners.DEEPIMMO.text[1]',
        'partner.partners.DEEPIMMO.text[2]',
      ],
      registrationLinkText: 'partner.partners.DEEPIMMO.registrationLinkText',
      registrationLink: 'partner.partners.DEEPIMMO.registrationLink',
      logo: 'img/deepimmo.jpg',
      tags: [PARTNER_TAGS.DATA],
    },
    MAKLERMITTELPUNKT: {
      subTitle: 'partner.partners.MAKLERMITTELPUNKT.subTitle',
      text: [
        'partner.partners.MAKLERMITTELPUNKT.text[0]',
        'partner.partners.MAKLERMITTELPUNKT.text[1]',
      ],
      registrationLinkText: 'partner.partners.MAKLERMITTELPUNKT.registrationLinkText',
      registrationLink: 'partner.partners.MAKLERMITTELPUNKT.registrationLink',
      logo: 'img/maklermittelpunkt.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    PIXELMOTION: {
      subTitle: 'partner.partners.PIXELMOTION.subTitle',
      text: ['partner.partners.PIXELMOTION.text[0]', 'partner.partners.PIXELMOTION.text[1]'],
      registrationLinkText: 'partner.partners.PIXELMOTION.registrationLinkText',
      registrationLink: 'partner.partners.PIXELMOTION.registrationLink',
      logo: 'img/pixelmotion.png',
      tags: [PARTNER_TAGS.CONTENT],
    },
    // REAL_X_LAB_PARTNER: {
    //   subTitle: 'partner.partners.REAL_X_LAB_PARTNER.subTitle',
    //   text: ['partner.partners.REAL_X_LAB_PARTNER.text[0]'],
    //   textWithLink: [
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[0].text',
    //     },
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[1].text',
    //     },
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[2].text',
    //     },
    //   ],
    //   registrationLink: 'partner.partners.REAL_X_LAB_PARTNER.registrationLink',
    //   registrationLinkText: 'partner.partners.REAL_X_LAB_PARTNER.registrationLinkText',
    //   logo: 'img/realxlab.png',
    //   tags: [PARTNER_TAGS.OTHER],
    //   code: 'bottimmo',
    // },
    LOCAL_ON_TOP_PARTNER: {
      subTitle: 'partner.partners.LOCAL_ON_TOP_PARTNER.subTitle',
      text: ['partner.partners.LOCAL_ON_TOP_PARTNER.text[0]'],
      registrationLink: 'partner.partners.LOCAL_ON_TOP_PARTNER.registrationLink',
      registrationLinkText: 'partner.partners.LOCAL_ON_TOP_PARTNER.registrationLinkText',
      code: 'Platzhirsch',
      logo: 'img/local-on-top.png',
      tags: [PARTNER_TAGS.SEO],
    },
    SINCHEN_MEDIA: {
      subTitle: 'partner.partners.SINCHEN_MEDIA.subTitle',
      text: [
        'partner.partners.SINCHEN_MEDIA.text[0]',
        'partner.partners.SINCHEN_MEDIA.text[1]',
        'partner.partners.SINCHEN_MEDIA.text[2]',
      ],
      registrationLink: 'partner.partners.SINCHEN_MEDIA.registrationLink',
      registrationLinkText: 'partner.partners.SINCHEN_MEDIA.registrationLinkText',
      logo: 'img/sinchenmedia.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    // MULTIPHONE: {
    //   subTitle: 'multiphone verwandelt Ihre Leads in einen Termin und hält Ihnen den Rücken frei.',
    //   text: ['Seit 1998 zählt multiphone zum festen Bestandteil der Immobilienbranche. Wir genießen das ununterbrochene Vertrauen von Immobilienmaklern dank einer zuverlässigen Zusammenarbeit. Wir bearbeiten täglich über 16.000 eingehende Gespräche mit einem hohen Anteil von Immobilienanbietern und Interessenten.',
    //     'Unser geschultes Akquise-Team ist ideal auf den Prozess mit BOTTIMMO eingestellt. In kürzester Zeit kontaktieren wir telefonisch Ihre neu gewonnenen Leads mit dem Ziel Termine für Sie zu generieren. Maximieren Sie die Erfolgsquote Ihrer Leads und starten Sie noch heute mit mehr Objektanbieter-Terminen!',
    //     'Sichern Sie sich jetzt Ihr Startguthaben von 25 Euro.'
    //   ],
    //   registrationLink: 'https://bottimmodeal.funnelcockpit.com/',
    //   logo: 'img/multiphone.png',
    //   tags: [PARTNER_TAGS.LEAD_QUALITY],
    //   registrationLinkText: 'Mehr dazu'
    // },
    ROCKET_SUITS: {
      subTitle: 'partner.partners.ROCKET_SUITS.subTitle',
      text: ['partner.partners.ROCKET_SUITS.text[0]', 'partner.partners.ROCKET_SUITS.text[1]'],
      registrationLink: 'partner.partners.ROCKET_SUITS.registrationLink',
      registrationLinkText: 'partner.partners.ROCKET_SUITS.registrationLinkText',
      logo: 'img/rocketsuits.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    BEWERTUNGSLOESCHER: {
      subTitle: 'partner.partners.BEWERTUNGSLOESCHER.subTitle',
      text: [
        'partner.partners.BEWERTUNGSLOESCHER.text[0]',
        'partner.partners.BEWERTUNGSLOESCHER.text[1]',
        'partner.partners.BEWERTUNGSLOESCHER.text[2]',
        'partner.partners.BEWERTUNGSLOESCHER.text[3]',
      ],
      registrationLink: 'partner.partners.BEWERTUNGSLOESCHER.registrationLink',
      registrationLinkText: 'partner.partners.BEWERTUNGSLOESCHER.registrationLinkText',
      logo: 'img/bewertungsloescher.jpg',
      tags: [PARTNER_TAGS.FEEDBACK_MANAGEMENT],
      code: 'bottimmo15',
    },
    STORYBOX: {
      subTitle: 'partner.partners.STORYBOX.subTitle',
      text: ['partner.partners.STORYBOX.text[0]', 'partner.partners.STORYBOX.text[1]'],
      registrationLink: 'partner.partners.STORYBOX.registrationLink',
      registrationLinkText: 'partner.partners.STORYBOX.registrationLinkText',
      logo: 'img/storybox.png',
      tags: [PARTNER_TAGS.CONTENT],
      code: 'BOTTIMMO',
    },
    CLICKLIFT: {
      subTitle: 'partner.partners.CLICKLIFT.subTitle',
      text: [
        'partner.partners.CLICKLIFT.text[0]',
        'partner.partners.CLICKLIFT.text[1]',
        'partner.partners.CLICKLIFT.text[2]',
      ],
      registrationLink: 'partner.partners.CLICKLIFT.registrationLink',
      registrationLinkText: 'partner.partners.CLICKLIFT.registrationLinkText',
      logo: 'img/clicklift.png',
      tags: [PARTNER_TAGS.SEO],
      code: '77#Mmo',
    },
    FIFY: {
      subTitle: 'partner.partners.FIFY.subTitle',
      text: [
        'partner.partners.FIFY.text[0]',
        'partner.partners.FIFY.text[1]',
        'partner.partners.FIFY.text[2]',
      ],
      registrationLink: 'partner.partners.FIFY.registrationLink',
      registrationLinkText: 'partner.partners.FIFY.registrationLinkText',
      logo: 'img/fify.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    MECOA: {
      subTitle: 'partner.partners.MECOA.subTitle',
      text: ['partner.partners.MECOA.text[0]'],
      registrationLink: 'partner.partners.MECOA.registrationLink',
      registrationLinkText: 'partner.partners.MECOA.registrationLinkText',
      logo: 'img/mecoa.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    VON_FRED: {
      subTitle: 'partner.partners.VON_FRED.subTitle',
      text: ['partner.partners.VON_FRED.text[0]', 'partner.partners.VON_FRED.text[1]'],
      registrationLink: 'partner.partners.VON_FRED.registrationLink',
      registrationLinkText: 'partner.partners.VON_FRED.registrationLinkText',
      logo: 'img/von-fred.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    REDCUP: {
      subTitle: 'partner.partners.REDCUP.subTitle',
      text: [
        'partner.partners.REDCUP.text[0]',
        'partner.partners.REDCUP.text[1]',
        'partner.partners.REDCUP.text[2]',
      ],
      registrationLink: 'partner.partners.REDCUP.registrationLink',
      registrationLinkText: 'partner.partners.REDCUP.registrationLinkText',
      logo: 'img/redcup.png',
      tags: [PARTNER_TAGS.SEO],
    },
    SOLOWERK: {
      subTitle: 'partner.partners.SOLOWERK.subTitle',
      text: ['partner.partners.SOLOWERK.text[0]', 'partner.partners.SOLOWERK.text[1]'],
      registrationLink: 'partner.partners.SOLOWERK.registrationLink',
      registrationLinkText: 'partner.partners.SOLOWERK.registrationLinkText',
      logo: 'img/solowerk.png',
      tags: [PARTNER_TAGS.CONTENT],
    },
    PIXELWERKSTATT: {
      subTitle: 'partner.partners.PIXELWERKSTATT.subTitle',
      text: [
        'partner.partners.PIXELWERKSTATT.text[0]',
        'partner.partners.PIXELWERKSTATT.text[1]',
        'partner.partners.PIXELWERKSTATT.text[2]',
      ],
      registrationLink: 'partner.partners.PIXELWERKSTATT.registrationLink',
      registrationLinkText: 'partner.partners.PIXELWERKSTATT.registrationLinkText',
      logo: 'img/pixelwerkstatt.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    JACASA: {
      subTitle: 'partner.partners.JACASA.subTitle',
      text: ['partner.partners.JACASA.text[0]', 'partner.partners.JACASA.text[1]'],
      registrationLink: 'partner.partners.JACASA.registrationLink',
      registrationLinkText: 'partner.partners.JACASA.registrationLinkText',
      logo: 'img/jacasa.png',
      tags: [PARTNER_TAGS.OTHER],
    },
    IMMOVIEWER: {
      subTitle: 'partner.partners.IMMOVIEWER.subTitle',
      text: ['partner.partners.IMMOVIEWER.text[0]', 'partner.partners.IMMOVIEWER.text[1]'],
      registrationLink: 'partner.partners.IMMOVIEWER.registrationLink',
      registrationLinkText: 'partner.partners.IMMOVIEWER.registrationLinkText',
      logo: 'img/immoviewer.png',
      tags: [PARTNER_TAGS.CONTENT],
      code: 'BOTTIMMO',
    },
    FPRE: {
      subTitle: 'partner.partners.FPRE.subTitle',
      text: [
        'partner.partners.FPRE.text[0]',
        'partner.partners.FPRE.text[1]',
        'partner.partners.FPRE.text[2]',
      ],
      registrationLink: 'partner.partners.FPRE.registrationLink',
      registrationLinkText: 'partner.partners.FPRE.registrationLinkText',
      logo: 'img/fpre.jpg',
      tags: [PARTNER_TAGS.DATA],
    },
    REGIONALIMMOBILIEN: {
      subTitle: 'partner.partners.REGIONALIMMOBILIEN.subTitle',
      text: [
        'partner.partners.REGIONALIMMOBILIEN.text[0]',
        'partner.partners.REGIONALIMMOBILIEN.text[1]',
      ],
      registrationLink: 'partner.partners.REGIONALIMMOBILIEN.registrationLink',
      registrationLinkText: 'partner.partners.REGIONALIMMOBILIEN.registrationLinkText',
      logo: 'img/regionalimmobilien.png',
      code: 'BOTTIMMO',
      tags: [PARTNER_TAGS.OTHER],
    },
    '4VISION': {
      subTitle: 'partner.partners.4VISION.subTitle',
      text: ['partner.partners.4VISION.text[0]', 'partner.partners.4VISION.text[1]'],
      registrationLink: 'partner.partners.4VISION.registrationLink',
      registrationLinkText: 'partner.partners.4VISION.registrationLinkText',
      logo: 'img/4vision.png',
      code: 'bottimmo1',
      tags: [PARTNER_TAGS.CONTENT, PARTNER_TAGS.OTHER],
    },
    YNFINITE: {
      subTitle: 'partner.partners.YNFINITE.subTitle',
      text: [
        'partner.partners.YNFINITE.text[0]',
        'partner.partners.YNFINITE.text[1]',
        'partner.partners.YNFINITE.text[2]',
      ],
      registrationLink: 'partner.partners.YNFINITE.registrationLink',
      registrationLinkText: 'partner.partners.YNFINITE.registrationLinkText',
      logo: 'img/ynfinite.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    IMMOW: {
      subTitle: 'partner.partners.IMMOW.subTitle',
      text: [
        'partner.partners.IMMOW.text[0]',
        'partner.partners.IMMOW.text[1]',
        'partner.partners.IMMOW.text[2]',
        'partner.partners.IMMOW.text[3]',
      ],
      registrationLink: 'partner.partners.IMMOW.registrationLink',
      registrationLinkText: 'partner.partners.IMMOW.registrationLinkText',
      code: 'BOTTIMMO-10',
      logo: 'img/immow.png',
      tags: [PARTNER_TAGS.LEARNING],
    },
    HOLO_LOGIX: {
      subTitle: 'partner.partners.HOLO_LOGIX.subTitle',
      text: ['partner.partners.HOLO_LOGIX.text[0]', 'partner.partners.HOLO_LOGIX.text[1]'],
      registrationLink: 'partner.partners.HOLO_LOGIX.registrationLink',
      registrationLinkText: 'partner.partners.HOLO_LOGIX.registrationLinkText',
      logo: 'img/holo_logix.jpg',
      tags: [PARTNER_TAGS.OTHER],
    },
    IMPROOV: {
      subTitle: 'partner.partners.IMPROOV.subTitle',
      text: ['partner.partners.IMPROOV.text[0]', 'partner.partners.IMPROOV.text[1]'],
      registrationLink: 'partner.partners.IMPROOV.registrationLink',
      registrationLinkText: 'partner.partners.IMPROOV.registrationLinkText',
      logo: 'img/improov.png',
      tags: [PARTNER_TAGS.OTHER],
    },
  },
  falc: {
    DEEPIMMO: {
      subTitle: 'partner.partners.DEEPIMMO.subTitle',
      text: [
        'partner.partners.DEEPIMMO.text[0]',
        'partner.partners.DEEPIMMO.text[1]',
        'partner.partners.DEEPIMMO.text[2]',
      ],
      registrationLinkText: 'partner.partners.DEEPIMMO.registrationLinkText',
      registrationLink: 'partner.partners.DEEPIMMO.registrationLink',
      logo: 'img/deepimmo.jpg',
      tags: [PARTNER_TAGS.DATA],
    },
    MAKLERMITTELPUNKT: {
      subTitle: 'partner.partners.MAKLERMITTELPUNKT.subTitle',
      text: [
        'partner.partners.MAKLERMITTELPUNKT.text[0]',
        'partner.partners.MAKLERMITTELPUNKT.text[1]',
      ],
      registrationLinkText: 'partner.partners.MAKLERMITTELPUNKT.registrationLinkText',
      registrationLink: 'partner.partners.MAKLERMITTELPUNKT.registrationLink',
      logo: 'img/maklermittelpunkt.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    PIXELMOTION: {
      subTitle: 'partner.partners.PIXELMOTION.subTitle',
      text: ['partner.partners.PIXELMOTION.text[0]', 'partner.partners.PIXELMOTION.text[1]'],
      registrationLinkText: 'partner.partners.PIXELMOTION.registrationLinkText',
      registrationLink: 'partner.partners.PIXELMOTION.registrationLink',
      logo: 'img/pixelmotion.png',
      tags: [PARTNER_TAGS.CONTENT],
    },
    // REAL_X_LAB_PARTNER: {
    //   subTitle: 'partner.partners.REAL_X_LAB_PARTNER.subTitle',
    //   text: ['partner.partners.REAL_X_LAB_PARTNER.text[0]'],
    //   textWithLink: [
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[0].text',
    //     },
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[1].text',
    //     },
    //     {
    //       text: 'partner.partners.REAL_X_LAB_PARTNER.textWithLink[2].text',
    //     },
    //   ],
    //   registrationLink: 'partner.partners.REAL_X_LAB_PARTNER.registrationLink',
    //   registrationLinkText: 'partner.partners.REAL_X_LAB_PARTNER.registrationLinkText',
    //   logo: 'img/realxlab.png',
    //   tags: [PARTNER_TAGS.OTHER],
    //   code: 'bottimmo',
    // },
    LOCAL_ON_TOP_PARTNER: {
      subTitle: 'partner.partners.LOCAL_ON_TOP_PARTNER.subTitle',
      text: ['partner.partners.LOCAL_ON_TOP_PARTNER.text[0]'],
      registrationLink: 'partner.partners.LOCAL_ON_TOP_PARTNER.registrationLink',
      registrationLinkText: 'partner.partners.LOCAL_ON_TOP_PARTNER.registrationLinkText',
      code: 'Platzhirsch',
      logo: 'img/local-on-top.png',
      tags: [PARTNER_TAGS.SEO],
    },
    SINCHEN_MEDIA: {
      subTitle: 'partner.partners.SINCHEN_MEDIA.subTitle',
      text: [
        'partner.partners.SINCHEN_MEDIA.text[0]',
        'partner.partners.SINCHEN_MEDIA.text[1]',
        'partner.partners.SINCHEN_MEDIA.text[2]',
      ],
      registrationLink: 'partner.partners.SINCHEN_MEDIA.registrationLink',
      registrationLinkText: 'partner.partners.SINCHEN_MEDIA.registrationLinkText',
      logo: 'img/sinchenmedia.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    // MULTIPHONE: {
    //   subTitle: 'multiphone verwandelt Ihre Leads in einen Termin und hält Ihnen den Rücken frei.',
    //   text: ['Seit 1998 zählt multiphone zum festen Bestandteil der Immobilienbranche. Wir genießen das ununterbrochene Vertrauen von Immobilienmaklern dank einer zuverlässigen Zusammenarbeit. Wir bearbeiten täglich über 16.000 eingehende Gespräche mit einem hohen Anteil von Immobilienanbietern und Interessenten.',
    //     'Unser geschultes Akquise-Team ist ideal auf den Prozess mit BOTTIMMO eingestellt. In kürzester Zeit kontaktieren wir telefonisch Ihre neu gewonnenen Leads mit dem Ziel Termine für Sie zu generieren. Maximieren Sie die Erfolgsquote Ihrer Leads und starten Sie noch heute mit mehr Objektanbieter-Terminen!',
    //     'Sichern Sie sich jetzt Ihr Startguthaben von 25 Euro.'
    //   ],
    //   registrationLink: 'https://bottimmodeal.funnelcockpit.com/',
    //   logo: 'img/multiphone.png',
    //   tags: [PARTNER_TAGS.LEAD_QUALITY],
    //   registrationLinkText: 'Mehr dazu'
    // },
    ROCKET_SUITS: {
      subTitle: 'partner.partners.ROCKET_SUITS.subTitle',
      text: ['partner.partners.ROCKET_SUITS.text[0]', 'partner.partners.ROCKET_SUITS.text[1]'],
      registrationLink: 'partner.partners.ROCKET_SUITS.registrationLink',
      registrationLinkText: 'partner.partners.ROCKET_SUITS.registrationLinkText',
      logo: 'img/rocketsuits.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    BEWERTUNGSLOESCHER: {
      subTitle: 'partner.partners.BEWERTUNGSLOESCHER.subTitle',
      text: [
        'partner.partners.BEWERTUNGSLOESCHER.text[0]',
        'partner.partners.BEWERTUNGSLOESCHER.text[1]',
        'partner.partners.BEWERTUNGSLOESCHER.text[2]',
        'partner.partners.BEWERTUNGSLOESCHER.text[3]',
      ],
      registrationLink: 'partner.partners.BEWERTUNGSLOESCHER.registrationLink',
      registrationLinkText: 'partner.partners.BEWERTUNGSLOESCHER.registrationLinkText',
      logo: 'img/bewertungsloescher.jpg',
      tags: [PARTNER_TAGS.FEEDBACK_MANAGEMENT],
      code: 'bottimmo15',
    },
    STORYBOX: {
      subTitle: 'partner.partners.STORYBOX.subTitle',
      text: ['partner.partners.STORYBOX.text[0]', 'partner.partners.STORYBOX.text[1]'],
      registrationLink: 'partner.partners.STORYBOX.registrationLink',
      registrationLinkText: 'partner.partners.STORYBOX.registrationLinkText',
      logo: 'img/storybox.png',
      tags: [PARTNER_TAGS.CONTENT],
      code: 'BOTTIMMO',
    },
    CLICKLIFT: {
      subTitle: 'partner.partners.CLICKLIFT.subTitle',
      text: [
        'partner.partners.CLICKLIFT.text[0]',
        'partner.partners.CLICKLIFT.text[1]',
        'partner.partners.CLICKLIFT.text[2]',
      ],
      registrationLink: 'partner.partners.CLICKLIFT.registrationLink',
      registrationLinkText: 'partner.partners.CLICKLIFT.registrationLinkText',
      logo: 'img/clicklift.png',
      tags: [PARTNER_TAGS.SEO],
      code: '77#Mmo',
    },
    FIFY: {
      subTitle: 'partner.partners.FIFY.subTitle',
      text: [
        'partner.partners.FIFY.text[0]',
        'partner.partners.FIFY.text[1]',
        'partner.partners.FIFY.text[2]',
      ],
      registrationLink: 'partner.partners.FIFY.registrationLink',
      registrationLinkText: 'partner.partners.FIFY.registrationLinkText',
      logo: 'img/fify.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    MECOA: {
      subTitle: 'partner.partners.MECOA.subTitle',
      text: ['partner.partners.MECOA.text[0]'],
      registrationLink: 'partner.partners.MECOA.registrationLink',
      registrationLinkText: 'partner.partners.MECOA.registrationLinkText',
      logo: 'img/mecoa.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    VON_FRED: {
      subTitle: 'partner.partners.VON_FRED.subTitle',
      text: ['partner.partners.VON_FRED.text[0]', 'partner.partners.VON_FRED.text[1]'],
      registrationLink: 'partner.partners.VON_FRED.registrationLink',
      registrationLinkText: 'partner.partners.VON_FRED.registrationLinkText',
      logo: 'img/von-fred.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    REDCUP: {
      subTitle: 'partner.partners.REDCUP.subTitle',
      text: [
        'partner.partners.REDCUP.text[0]',
        'partner.partners.REDCUP.text[1]',
        'partner.partners.REDCUP.text[2]',
      ],
      registrationLink: 'partner.partners.REDCUP.registrationLink',
      registrationLinkText: 'partner.partners.REDCUP.registrationLinkText',
      logo: 'img/redcup.png',
      tags: [PARTNER_TAGS.SEO],
    },
    SOLOWERK: {
      subTitle: 'partner.partners.SOLOWERK.subTitle',
      text: ['partner.partners.SOLOWERK.text[0]', 'partner.partners.SOLOWERK.text[1]'],
      registrationLink: 'partner.partners.SOLOWERK.registrationLink',
      registrationLinkText: 'partner.partners.SOLOWERK.registrationLinkText',
      logo: 'img/solowerk.png',
      tags: [PARTNER_TAGS.CONTENT],
    },
    PIXELWERKSTATT: {
      subTitle: 'partner.partners.PIXELWERKSTATT.subTitle',
      text: [
        'partner.partners.PIXELWERKSTATT.text[0]',
        'partner.partners.PIXELWERKSTATT.text[1]',
        'partner.partners.PIXELWERKSTATT.text[2]',
      ],
      registrationLink: 'partner.partners.PIXELWERKSTATT.registrationLink',
      registrationLinkText: 'partner.partners.PIXELWERKSTATT.registrationLinkText',
      logo: 'img/pixelwerkstatt.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    JACASA: {
      subTitle: 'partner.partners.JACASA.subTitle',
      text: ['partner.partners.JACASA.text[0]', 'partner.partners.JACASA.text[1]'],
      registrationLink: 'partner.partners.JACASA.registrationLink',
      registrationLinkText: 'partner.partners.JACASA.registrationLinkText',
      logo: 'img/jacasa.png',
      tags: [PARTNER_TAGS.OTHER],
    },
    IMMOVIEWER: {
      subTitle: 'partner.partners.IMMOVIEWER.subTitle',
      text: ['partner.partners.IMMOVIEWER.text[0]', 'partner.partners.IMMOVIEWER.text[1]'],
      registrationLink: 'partner.partners.IMMOVIEWER.registrationLink',
      registrationLinkText: 'partner.partners.IMMOVIEWER.registrationLinkText',
      logo: 'img/immoviewer.png',
      tags: [PARTNER_TAGS.CONTENT],
      code: 'BOTTIMMO',
    },
    FPRE: {
      subTitle: 'partner.partners.FPRE.subTitle',
      text: [
        'partner.partners.FPRE.text[0]',
        'partner.partners.FPRE.text[1]',
        'partner.partners.FPRE.text[2]',
      ],
      registrationLink: 'partner.partners.FPRE.registrationLink',
      registrationLinkText: 'partner.partners.FPRE.registrationLinkText',
      logo: 'img/fpre.jpg',
      tags: [PARTNER_TAGS.DATA],
    },
    REGIONALIMMOBILIEN: {
      subTitle: 'partner.partners.REGIONALIMMOBILIEN.subTitle',
      text: [
        'partner.partners.REGIONALIMMOBILIEN.text[0]',
        'partner.partners.REGIONALIMMOBILIEN.text[1]',
      ],
      registrationLink: 'partner.partners.REGIONALIMMOBILIEN.registrationLink',
      registrationLinkText: 'partner.partners.REGIONALIMMOBILIEN.registrationLinkText',
      logo: 'img/regionalimmobilien.png',
      code: 'BOTTIMMO',
      tags: [PARTNER_TAGS.OTHER],
    },
    '4VISION': {
      subTitle: 'partner.partners.4VISION.subTitle',
      text: ['partner.partners.4VISION.text[0]', 'partner.partners.4VISION.text[1]'],
      registrationLink: 'partner.partners.4VISION.registrationLink',
      registrationLinkText: 'partner.partners.4VISION.registrationLinkText',
      logo: 'img/4vision.png',
      code: 'bottimmo1',
      tags: [PARTNER_TAGS.CONTENT, PARTNER_TAGS.OTHER],
    },
    YNFINITE: {
      subTitle: 'partner.partners.YNFINITE.subTitle',
      text: [
        'partner.partners.YNFINITE.text[0]',
        'partner.partners.YNFINITE.text[1]',
        'partner.partners.YNFINITE.text[2]',
      ],
      registrationLink: 'partner.partners.YNFINITE.registrationLink',
      registrationLinkText: 'partner.partners.YNFINITE.registrationLinkText',
      logo: 'img/ynfinite.png',
      tags: [PARTNER_TAGS.WEBSITE_DEVELOPMENT],
    },
    IMMOW: {
      subTitle: 'partner.partners.IMMOW.subTitle',
      text: [
        'partner.partners.IMMOW.text[0]',
        'partner.partners.IMMOW.text[1]',
        'partner.partners.IMMOW.text[2]',
        'partner.partners.IMMOW.text[3]',
      ],
      registrationLink: 'partner.partners.IMMOW.registrationLink',
      registrationLinkText: 'partner.partners.IMMOW.registrationLinkText',
      code: 'BOTTIMMO-10',
      logo: 'img/immow.png',
      tags: [PARTNER_TAGS.LEARNING],
    },
    HOLO_LOGIX: {
      subTitle: 'partner.partners.HOLO_LOGIX.subTitle',
      text: ['partner.partners.HOLO_LOGIX.text[0]', 'partner.partners.HOLO_LOGIX.text[1]'],
      registrationLink: 'partner.partners.HOLO_LOGIX.registrationLink',
      registrationLinkText: 'partner.partners.HOLO_LOGIX.registrationLinkText',
      logo: 'img/holo_logix.jpg',
      tags: [PARTNER_TAGS.OTHER],
    },
    IMPROOV: {
      subTitle: 'partner.partners.IMPROOV.subTitle',
      text: ['partner.partners.IMPROOV.text[0]', 'partner.partners.IMPROOV.text[1]'],
      registrationLink: 'partner.partners.IMPROOV.registrationLink',
      registrationLinkText: 'partner.partners.IMPROOV.registrationLinkText',
      logo: 'img/improov.png',
      tags: [PARTNER_TAGS.OTHER],
    },
  },
  smg: {
    VON_FRED: {
      subTitle: 'partner.partners.VON_FRED.smg.subTitle',
      text: ['partner.partners.VON_FRED.smg.text[0]', 'partner.partners.VON_FRED.smg.text[1]'],
      registrationLink: 'partner.partners.VON_FRED.smg.registrationLink',
      registrationLinkText: 'partner.partners.VON_FRED.smg.registrationLinkText',
      logo: 'img/von-fred.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    REDCUP: {
      subTitle: 'partner.partners.REDCUP.smg.subTitle',
      text: [
        'partner.partners.REDCUP.smg.text[0]',
        'partner.partners.REDCUP.smg.text[1]',
        'partner.partners.REDCUP.smg.text[2]',
      ],
      registrationLink: 'partner.partners.REDCUP.smg.registrationLink',
      registrationLinkText: 'partner.partners.REDCUP.smg.registrationLinkText',
      logo: 'img/redcup.png',
      tags: [PARTNER_TAGS.SEO],
    },
    SELLER_LEADS: {
      subTitle: 'partner.partners.SELLER_LEADS.smg.subTitle',
      text: [
        'partner.partners.SELLER_LEADS.smg.text[0]',
        'partner.partners.SELLER_LEADS.smg.text[1]',
      ],
      registrationLink: 'partner.partners.SELLER_LEADS.smg.registrationLink',
      registrationLinkText: 'partner.partners.SELLER_LEADS.smg.registrationLinkText',
      logo: 'img/sellerLeads.png',
      tags: [PARTNER_TAGS.LEAD_QUALITY],
    },
    DISPLAY_WERBUNG: {
      subTitle: 'partner.partners.DISPLAY_WERBUNG.smg.subTitle',
      text: [
        'partner.partners.DISPLAY_WERBUNG.smg.text[0]',
        'partner.partners.DISPLAY_WERBUNG.smg.text[1]',
      ],
      registrationLink: 'partner.partners.DISPLAY_WERBUNG.smg.registrationLink',
      registrationLinkText: 'partner.partners.DISPLAY_WERBUNG.smg.registrationLinkText',
      logo: 'img/displaywerbung.png',
      tags: [PARTNER_TAGS.OTHER],
    },
    VISIBILITY_PLUS: {
      subTitle: 'partner.partners.VISIBILITY_PLUS.smg.subTitle',
      text: [
        'partner.partners.VISIBILITY_PLUS.smg.text[0]',
        'partner.partners.VISIBILITY_PLUS.smg.text[1]',
      ],
      registrationLink: 'partner.partners.VISIBILITY_PLUS.smg.registrationLink',
      registrationLinkText: 'partner.partners.VISIBILITY_PLUS.smg.registrationLinkText',
      logo: 'img/visibility.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    REGIONAL_HIGHLIGHT: {
      subTitle: 'partner.partners.REGIONAL_HIGHLIGHT.smg.subTitle',
      text: [
        'partner.partners.REGIONAL_HIGHLIGHT.smg.text[0]',
        'partner.partners.REGIONAL_HIGHLIGHT.smg.text[1]',
      ],
      registrationLink: 'partner.partners.REGIONAL_HIGHLIGHT.smg.registrationLink',
      registrationLinkText: 'partner.partners.REGIONAL_HIGHLIGHT.smg.registrationLinkText',
      logo: 'img/regionalHighlight.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
  },
  remax: {
    VON_FRED: {
      subTitle: 'partner.partners.VON_FRED.remax.subTitle',
      text: [
        'partner.partners.VON_FRED.remax.text[0]',
        'partner.partners.VON_FRED.remax.text[1]',
        'partner.partners.VON_FRED.remax.text[2]',
        'partner.partners.VON_FRED.remax.text[3]',
      ],
      registrationLink: 'partner.partners.VON_FRED.remax.registrationLink',
      registrationLinkText: 'partner.partners.VON_FRED.remax.registrationLinkText',
      logo: 'img/von-fred.png',
      tags: [PARTNER_TAGS.SOCIAL_MEDIA],
    },
    REDCUP: {
      subTitle: 'partner.partners.REDCUP.remax.subTitle',
      text: [
        'partner.partners.REDCUP.remax.text[0]',
        'partner.partners.REDCUP.remax.text[1]',
        'partner.partners.REDCUP.remax.text[2]',
        'partner.partners.REDCUP.remax.text[3]',
        'partner.partners.REDCUP.remax.text[4]',
      ],
      registrationLink: 'partner.partners.REDCUP.remax.registrationLink',
      registrationLinkText: 'partner.partners.REDCUP.remax.registrationLinkText',
      logo: 'img/redcup.png',
      tags: [PARTNER_TAGS.SEO],
    },
    MAXX_CAPITAL: {
      subTitle: 'partner.partners.MAXX_CAPITAL.remax.subTitle',
      text: [
        'partner.partners.MAXX_CAPITAL.remax.text[0]',
        'partner.partners.MAXX_CAPITAL.remax.text[1]',
        'partner.partners.MAXX_CAPITAL.remax.text[2]',
      ],
      registrationLink: 'partner.partners.MAXX_CAPITAL.remax.registrationLink',
      registrationLinkText: 'partner.partners.MAXX_CAPITAL.remax.registrationLinkText',
      logo: 'img/maxxcapital.png',
      tags: [PARTNER_TAGS.OTHER],
    },
    MAXX_FINANCE: {
      subTitle: 'partner.partners.MAXX_FINANCE.remax.subTitle',
      text: ['partner.partners.MAXX_FINANCE.remax.text[0]'],
      registrationLink: 'partner.partners.MAXX_FINANCE.remax.registrationLink',
      registrationLinkText: 'partner.partners.MAXX_FINANCE.remax.registrationLinkText',
      logo: 'img/maxxfinance.png',
      tags: [PARTNER_TAGS.OTHER],
    },
    LOCAL_ON_TOP_PARTNER: {
      subTitle: 'partner.partners.LOCAL_ON_TOP_PARTNER.remax.subTitle',
      text: ['partner.partners.LOCAL_ON_TOP_PARTNER.remax.text[0]'],
      registrationLink: 'partner.partners.LOCAL_ON_TOP_PARTNER.remax.registrationLink',
      registrationLinkText: 'partner.partners.LOCAL_ON_TOP_PARTNER.remax.registrationLinkText',
      logo: 'img/local-on-top.png',
      tags: [PARTNER_TAGS.SEO],
    },
  },
}

// Supported locales for each platform
export const SUPPORTED_LOCALES = {
  bottimmo: ['de', 'en'],
  smg: ['de', 'en', 'fr', 'it'],
  remax: ['de', 'en'],
  falc: ['de', 'en'],
}

/**
 * Maps a given locale to a supported locale for the specified platform
 * @param {string} locale - The current locale (e.g., 'de-CH', 'en-US', 'fr-CH')
 * @param {string} platform - The platform ('bottimmo', 'smg', 'remax')
 * @returns {string} - The mapped locale that exists in PARTNER_TYPES
 */
export function LocaleMapper(locale, platform) {
  // Get supported locales for the platform
  const supportedLocales = SUPPORTED_LOCALES[platform] || []

  // If the exact locale is supported, return it
  if (supportedLocales.includes(locale)) {
    return locale
  }

  // Extract the base language code (e.g., 'de' from 'de-CH')
  const baseLanguage = locale.split('-')[0]

  // If the base language is supported, return it
  if (supportedLocales.includes(baseLanguage)) {
    return baseLanguage
  }

  // Fallback to the first supported locale (usually 'de' or 'en')
  return supportedLocales[0] || 'de'
}
